import React from "react";

export const CheckedIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M16 0.375H2C0.89 0.375 0 1.275 0 2.375V16.375C0 17.475 0.89 18.375 2 18.375H16C17.11 18.375 18 17.475 18 16.375V2.375C18 1.275 17.11 0.375 16 0.375ZM7 14.375L2 9.375L3.41 7.965L7 11.545L14.59 3.955L16 5.375L7 14.375Z"
        fill="var(--inzeloop-ds-color-action-primary-pressed)"
      />
    </svg>
  );
};
